// src/student/components/StudentHeader.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, BookOpen, ExternalLink, ShieldCheck } from "lucide-react";
import { useStudentAuth } from "../context/StudentAuthContext";

const pageTitles = {
  "/student/dashboard": "Aspirant Dashboard",
  "/student/daily-ca": "Daily Current Affairs Archive",
  "/student/monthly-ca": "Monthly Current Affairs Compendiums",
  "/student/prelims": "Free Prelims Test Series",
  "/student/mains": "Mains Daily Answer Writing (DAW)",
  "/student/results": "My Performance & Evaluations",
  "/student/profile": "Student Profile & Credentials",
};

const StudentHeader = ({ setIsMobileOpen }) => {
  const location = useLocation();
  const { studentUser } = useStudentAuth();

  const title = pageTitles[location.pathname] || "Free UPSC Initiative Portal";

  return (
    <header className="h-16 bg-white border-b border-slate-200/80 px-4 sm:px-6 flex items-center justify-between sticky top-0 z-30 shadow-2xs">
      <div className="flex items-center gap-3">
        <button
          onClick={() => setIsMobileOpen(true)}
          className="md:hidden text-slate-500 hover:text-slate-800 p-1.5 rounded-lg hover:bg-slate-100"
        >
          <Menu size={20} />
        </button>
        <div>
          <h1 className="text-sm sm:text-base font-bold text-slate-900 tracking-tight">
            {title}
          </h1>
          <p className="text-[11px] text-slate-400 hidden sm:block">
            Selva's IAS Academy • Empowering Aspirants with Quality UPSC Guidance
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {/* Main Website Link */}
        <Link
          to="/"
          className="hidden sm:flex items-center gap-1.5 text-xs font-semibold text-slate-600 hover:text-red-900 px-3 py-1.5 rounded-lg border border-slate-200 hover:border-red-200 hover:bg-red-50/50 transition-colors"
        >
          <BookOpen size={13} />
          <span>Academy Website</span>
          <ExternalLink size={11} className="opacity-60" />
        </Link>

        {/* Student Avatar / Reg Id Pill */}
        <div className="flex items-center gap-2 pl-2 border-l border-slate-200">
          <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-red-900 to-amber-600 text-white font-bold text-xs flex items-center justify-center shadow-xs">
            {studentUser?.name ? studentUser.name.charAt(0).toUpperCase() : "U"}
          </div>
          <div className="hidden lg:block text-left">
            <span className="block text-xs font-bold text-slate-800 truncate leading-tight">
              {studentUser?.name || "Student"}
            </span>
            <span className="block text-[10px] text-slate-400 font-mono flex items-center gap-1">
              <ShieldCheck size={10} className="text-emerald-500" />
              {studentUser?.registrationId || "SIA-2026"}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default StudentHeader;
